var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Image",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "NoPath_-_Copy",
    "data-name": "NoPath - Copy",
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_20",
    "data-name": "Mask Group 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(-2.572 -2.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M7.072,7.714h27a3.215,3.215,0,0,1,3.214,3.215V30.215a3.215,3.215,0,0,1-3.214,3.214h-27a3.215,3.215,0,0,1-3.215-3.214V10.929A3.215,3.215,0,0,1,7.072,7.714Z",
    fill: "none",
    stroke: "#7367f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.571
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M9,12.857l11.571,9,11.571-9",
    fill: "none",
    stroke: "#7367f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.571
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b85e63a08c7ffb994c5ce198a35d537b.svg";
export { ForwardRef as ReactComponent };